import { Box, Typography } from '@mui/material';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types';
import React from 'react';
import { SnackbarContent } from 'notistack';
import makeStyles from '@mui/styles/makeStyles';
import styles from './NotificationSavedToast.styles';

const useStyles = makeStyles(styles);

/**
 * Success toast shown after notification settings are saved. Rendered via
 * notistack's per-snackbar `content`, so it fully replaces the default snackbar
 * node — a white card with a green check and bold label, and no close button.
 * `SnackbarContent` forwards the ref notistack attaches for its transitions.
 */
const NotificationSavedToast = React.forwardRef((props, ref) => {
    const { message } = props;
    const classes = useStyles(props);

    return (
        <SnackbarContent ref={ref}>
            <Box className={classes.toast} data-testid="notification-saved-toast">
                <CheckCircleIcon className={classes.icon} />
                <Typography className={classes.label}>{message}</Typography>
            </Box>
        </SnackbarContent>
    );
});

NotificationSavedToast.displayName = 'NotificationSavedToast';

NotificationSavedToast.propTypes = {
    message: PropTypes.node,
};

export default NotificationSavedToast;
